import { disablePageScroll, enablePageScroll } from "@fluejs/noscroll";

export class MobileMenu {
	constructor() {
		this.dialog = document.querySelector(".mobile-menu__dialog");
		this.menuButton = document.querySelector(
			".mobile-menu__closed-container .mobile-menu__button"
		);
		this.closeButton = this.dialog?.querySelector(".mobile-menu__button");

		this.dialog?.addEventListener("close", this.onCloseMenu);
		this.menuButton?.addEventListener("click", this.openMenu);
		this.closeButton?.addEventListener("click", this.closeMenu);

		this.setupHeroLogoAnimation();
	}

	openMenu = () => {
		this.dialog?.showModal();

		// Focus the dialog instead of the first element
		// because in Safari, focus would be visibly (!) set on the close button
		// even if the user is not using the keyboard.
		this.dialog?.focus();
		disablePageScroll();
	};

	closeMenu = () => {
		this.dialog?.close();
	};

	onCloseMenu = () => {
		enablePageScroll();
	};

	setupHeroLogoAnimation() {
		this.logoAfterHero = document.querySelector(
			".mobile-menu__hero-logo-container"
		);
		this.logoAfterHeroTopPart =
			this.logoAfterHero?.querySelector(".logo__part--top");

		if (!this.logoAfterHero || !this.logoAfterHeroTopPart) {
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.logoAfterHeroTopPart?.classList.remove("visible");
					} else {
						this.logoAfterHeroTopPart?.classList.add("visible");
					}
				});
			},
			{
				root: null,
				rootMargin: "-15% 0px 0px 0px", // Shrink the root by 15% from the top
				threshold: 0,
			}
		);

		observer.observe(this.logoAfterHero);
	}
}
